import React from 'react'
import { AppMessageTemplateStyle } from '@pushly/models/lib/enums/app-messages/app-message-template-style'

type AppMessageStyleDiagramProps = {
    style: AppMessageTemplateStyle
}

/**
 * Where on the screen each style appears, as a phone outline with the message
 * area filled in. Deliberately schematic — it answers "how much of the screen
 * does this take", not "what will it look like". The preview answers the latter.
 */
export const AppMessageStyleDiagram = ({ style }: AppMessageStyleDiagramProps) => (
    <svg width="26" height="34" viewBox="0 0 26 34" role="presentation" focusable="false">
        <rect x="0.5" y="0.5" width="25" height="33" rx="3" fill="none" stroke="currentColor" opacity="0.35" />

        {style === AppMessageTemplateStyle.MODAL && (
            <rect x="4" y="11" width="18" height="12" rx="2" fill="currentColor" opacity="0.7" />
        )}
        {style === AppMessageTemplateStyle.BANNER && (
            <rect x="3" y="4" width="20" height="6" rx="1.5" fill="currentColor" opacity="0.7" />
        )}
        {style === AppMessageTemplateStyle.FULLSCREEN && (
            <rect x="2.5" y="2.5" width="21" height="29" rx="2" fill="currentColor" opacity="0.7" />
        )}
    </svg>
)
